import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import SlideModal from '@/Atoms/SlideModal';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs, WINDOW_HEIGHT, WINDOW_WIDTH} from '@/Utils/Dimensions';
import React, {useState} from 'react';
import {Platform, View} from 'react-native';
import {RFPercentage} from 'react-native-responsive-fontsize';

interface TournamentEndedModalProps {
  isVisible: boolean;
  handleClose: () => void;
  rank: string | number;
  totalPlayers: number | string;
  totalRoundsPlayed: number | string;
  WonMatches?: number | string;
  LostMatches?: number | string;
  DrawnMatches?: number | string;
  BlitzRating: number | string;
  handleViewStandings: () => void;
  score: number | string;
}

const TournamentEndedModal: React.FC<TournamentEndedModalProps> = ({
  isVisible,
  handleClose,
  rank,
  totalPlayers,
  totalRoundsPlayed,
  WonMatches,
  LostMatches,
  DrawnMatches,
  BlitzRating,
  handleViewStandings,
  score,
}) => {
  const [boxWidth, setBoxWidth] = useState(0);
  const isMobileOrTab = useMediaQuery();
  const handleLayout = (e: any) => {
    const {width} = e.nativeEvent.layout;
    setBoxWidth(width);
  };
  return (
    <SlideModal
      visible={isVisible}
      onClose={handleClose}
      modalHeaderTitle={''}
      showCloseIcon={true}
      type="center"
      customHeaderStyle={{
        marginBottom: 0,
      }}
      minWidth={WINDOW_WIDTH / 3}
      contentPadding={0}
      customCenterModalMargin={-5}>
      <Box
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        style={Platform.OS === 'web' && {}}>
        <Box
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: CCColors.Green,
            borderRadius: isMobileOrTab ? 100 : '50%',
            height: isMobileOrTab ? 70 : 100,
            width: isMobileOrTab ? 70 : 100,
          }}>
          <CCText
            fontWeight="bold"
            color={CCColors.White}
            fontSize={RFPercentage(3.4)}>
            {rank}
          </CCText>
        </Box>
        <CCText
          style={{
            paddingVertical: vs(14),
          }}
          color={CCColors.Black}
          fontWeight={500}
          fontSize={FontSizes[24]}>
          You ranked #{rank} out of {totalPlayers}
        </CCText>

        <Box
          onLayout={handleLayout}
          flexDirection="column"
          style={
            Platform.OS === 'web'
              ? {
                  backgroundColor: CCColors.Primary.lightBrown,
                  padding: isMobileOrTab ? vs(10) : vs(20),
                  borderRadius: 10,
                  width: '70%',
                }
              : {
                  backgroundColor: CCColors.Primary.lightBrown,
                  padding: vs(10),
                  borderRadius: 10,
                }
          }>
          {/* <Box
              flexDirection="row"
              justifyContent="space-between"
              style={{ paddingVertical: vs(5), width: "100%" }}
            >
              <CCText fontSize={RFPercentage(1.8)}>Total rounds</CCText>
              <CCText fontWeight={600} fontSize={RFPercentage(1.6)}>
                {totalMatchesPlayed}
              </CCText>
            </Box> */}
          <Box
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            style={{paddingVertical: vs(5), width: '100%'}}>
            <CCText fontSize={RFPercentage(1.8)}>Total rounds</CCText>
            <CCText fontWeight={600} fontSize={RFPercentage(1.6)}>
              {totalRoundsPlayed}
            </CCText>
          </Box>
          <Box
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            style={{paddingVertical: vs(5), width: '100%'}}>
            <CCText fontSize={RFPercentage(1.8)}>Your score</CCText>
            <CCText
              color={CCColors.Green}
              fontWeight={600}
              fontSize={RFPercentage(1.6)}>
              {score}
            </CCText>
          </Box>
          {/* <Box
              flexDirection="row"
              justifyContent="space-between"
              style={{ paddingVertical: vs(5), width: "100%" }}
            >
              <CCText fontSize={RFPercentage(1.8)}>Matches won</CCText>
              <CCText
                color={CCColors.Green}
                fontWeight={600}
                fontSize={RFPercentage(1.6)}
              >
                {WonMatches}
              </CCText>
            </Box>
            <Box
              flexDirection="row"
              justifyContent="space-between"
              style={{ paddingVertical: vs(5), width: "100%" }}
            >
              <CCText fontSize={RFPercentage(1.8)}>Matches lost</CCText>
              <CCText
                color={CCColors.Red}
                fontWeight={600}
                fontSize={RFPercentage(1.6)}
              >
                {LostMatches}
              </CCText>
            </Box>
            <Box
              flexDirection="row"
              justifyContent="space-between"
              style={{ paddingVertical: vs(5), width: "100%" }}
            >
              <CCText fontSize={RFPercentage(1.8)}>Matches drawn</CCText>
              <CCText
                color={CCColors.EvaluationScore.Background}
                fontWeight={600}
                fontSize={RFPercentage(1.6)}
              >
                {DrawnMatches}
              </CCText>
            </Box> */}
          <Box
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            style={{paddingVertical: vs(5), width: '100%'}}>
            <CCText fontSize={RFPercentage(1.8)}>Your rating</CCText>
            <CCText fontWeight={600} fontSize={RFPercentage(1.6)}>
              {BlitzRating}
            </CCText>
          </Box>
        </Box>
        <CCButton
          style={{
            width: boxWidth,
            marginVertical: vs(15),
          }}
          contentContainerStyle={{paddingVertical: 10, paddingHorizontal: 0}}
          onPress={handleViewStandings}>
          <CCText fontSize={isMobileOrTab ? FontSizes[18] : RFPercentage(2)}>
            View Standings
          </CCText>
        </CCButton>
      </Box>
    </SlideModal>
  );
};

export default TournamentEndedModal;
